import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const REVISE_ROOT_ENTITY = `[${ModuleConfiguration.moduleName}] Revise Root Entity`;

export class ReviseRootEntityAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REVISE_ROOT_ENTITY;

  constructor(public payload: { entityKey: string, key: string, model: any, scope: string }) {}
}


// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/ReviseRootEntityAction.ts